"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetUnionFind = void 0;
class NetUnionFind {
    constructor() {
        this.parent = new Map();
        this.rank = new Map();
    }
    makeSet(item) {
        if (this.parent.has(item)) {
            return;
        }
        this.parent.set(item, item);
        this.rank.set(item, 0);
    }
    find(item) {
        let root = this.parent.get(item);
        if (root === undefined) {
            throw new Error('Item not found in union-find');
        }
        while (this.parent.get(root) !== root) {
            root = this.parent.get(root);
        }
        let current = item;
        while (current !== root) {
            const next = this.parent.get(current);
            this.parent.set(current, root);
            current = next;
        }
        return root;
    }
    union(a, b) {
        const rootA = this.find(a);
        const rootB = this.find(b);
        if (rootA === rootB) {
            return rootA;
        }
        const rankA = this.rank.get(rootA);
        const rankB = this.rank.get(rootB);
        if (rankA < rankB) {
            this.parent.set(rootA, rootB);
            return rootB;
        }
        else if (rankA > rankB) {
            this.parent.set(rootB, rootA);
            return rootA;
        }
        else {
            this.parent.set(rootB, rootA);
            this.rank.set(rootA, rankA + 1);
            return rootA;
        }
    }
    connected(a, b) {
        return this.find(a) === this.find(b);
    }
    has(item) {
        return this.parent.has(item);
    }
    getComponents() {
        const components = new Map();
        for (const item of this.parent.keys()) {
            const root = this.find(item);
            let component = components.get(root);
            if (!component) {
                component = [];
                components.set(root, component);
            }
            component.push(item);
        }
        return components;
    }
    clear() {
        this.parent.clear();
        this.rank.clear();
    }
    get size() {
        return this.parent.size;
    }
}
exports.NetUnionFind = NetUnionFind;
//# sourceMappingURL=NetUnionFind.js.map